import { gql } from "@apollo/client";

export const GET_PROFESIONALES_DERIVADOR_PAGINATED = gql`
query GetAllProfesionalesDerivador(
    $skip: Int
    $take: Int
    $where: t_ProfesionalDerivadorFilterInput 
) {
    allProfesionalDerivador(skip: $skip, take: $take, where: $where)
    {
        items {
            idProfesionalderivador
            nombre
            apellido
            idTipoProfesionalNavigation {
              idTipoProfesional,
              descripcion
            }      
            profDerivadorMatricula {
                numero,
                idOrigenMatriculaNavigation {
                  idOrigenMatricula,
                  descripcion
                }
            }    
        }
        totalCount
    }
}`;

export const adaptProfesionalDerivador = (profesional) => {
  return {
    codigoProfesional: profesional?.idProfesionalderivador,
    nombre: profesional?.nombre,
    apellido: profesional?.apellido,
    nombreyapellido: profesional?.nombre + " " + profesional?.apellido,
    tipoProfesional: profesional?.idTipoProfesionalNavigation?.descripcion,
    matricula: profesional?.profDerivadorMatricula?.map((matricula) => {return matricula.idOrigenMatriculaNavigation.descripcion + "-" + matricula.numero + (profesional?.profDerivadorMatricula?.length > 1 ? ";" : "");})
  };
};

export const adaptProfesionalesDerivadorArray = (
profesionales) =>
{
  return structuredClone(profesionales)?.
  map((profesional) => adaptProfesionalDerivador(profesional));
};